
import Base from '../../ts/_base';
import NavMenu from './templates/side-menu/nav-menu-client.jade';
import Slider from '../multi-level-slide-menu/ts/_multi-level-slider';
import SliderScreen from '../multi-level-slide-menu/ts/_slide-screen';
import { PageBuilder } from '../../ts/utils';

export default class SideMenu extends Base {

    sideMenuSections: {name: string, handler: () => void}[];
    slider: Slider;

    get selectors() {
        return {
            loginBar: '.login-bar',
            sideMenuLoginBar: '.side-menu__user-login-bar',
            navMenu: '.main-menu__nav',
            sideMenuNavMenu: '.side-menu__nav-menu',
            topicsButton: '.topicsButton',
            navItem: '.nav-item',
            dropdownToggle: '.dropdown-toggle',
            dropdownItem: '.dropdown-item',
            navLink: '.nav-link',
            topicsTabs: '.topics-tab',
            tabHeading: '.nav-item a span',
            tabContent: '.tab-pane'
        }   
    }

    constructor(sliderId = "side-menu") {
        super();
        this.sideMenuSections = [];
        this.slider = new Slider(sliderId);
        this.registerSections('login', this.createCloneHandler(this.selectors.loginBar, this.selectors.sideMenuLoginBar));
        this.registerSections('nav-menu', this.createNavMenuHandler(this.selectors.navMenu, this.selectors.sideMenuNavMenu, this.selectors.topicsButton));
        this.buildTopicTabsAsScreens();
        
    }

    initialize(): void {
        PageBuilder.afterInit().then( () => {
            this.slider.build();
            this.sideMenuSections.map(({handler}) => handler());
    })
    }


    registerSections(name, handler): void {
        this.sideMenuSections.push({ name, handler });
    }

    createCloneHandler(fromSelector: string | string[],  toSelector: string): () => void {
        return () => {
            if(!(fromSelector instanceof Array)) fromSelector = [fromSelector];
            let nodesToCopy;
            if(fromSelector.length > 0 && typeof fromSelector[0] === 'string') {
                nodesToCopy = fromSelector
                .map((s) => this.queryElm(s))
                .filter(n => n)
                .map(n => this.cloneElm(n))
                .flat(Infinity);
            } else {
                nodesToCopy = fromSelector;
            }
            nodesToCopy.forEach(elm => {
                (this.queryElm('[id]', true, elm) as NodeListOf<HTMLElement>).forEach(elmWithId => {
                    elmWithId.id = `${elmWithId.id}__copied`;
                })
            })
            const nodeToCopyTo = this.queryElm(toSelector) as HTMLElement;
            if(!nodeToCopyTo || nodesToCopy.length === 0) return;
            nodesToCopy.map(n => nodeToCopyTo.append(n));
        }
    }


    createNavMenuHandler(fromSelector: string, toSelector: string, topicsSelector: string): () => void {
        return () => {
            const menu = this.queryElm(fromSelector);
            const newParent = this.queryElm(toSelector) as HTMLElement;
            if(!menu || !newParent) return;
            const menuClone = this.cloneElm(menu);
            const topicsElm = menuClone.querySelector(topicsSelector);
            if(topicsElm && topicsElm.parentNode.nodeName === 'LI') 
                (topicsElm.parentNode as HTMLElement).remove();
            const menuItems = menuClone.querySelectorAll(this.selectors.navItem) as any;
            const menuItemsJson = [...menuItems]
            .filter(n => n)
            .filter(n => n.innerText)
            .map((item) => {
                const title = item.querySelector(this.selectors.dropdownToggle);
                if(title) 
                    return {
                        title: title.innerHTML,
                        children: [...item.querySelectorAll(this.selectors.dropdownItem)].map((link) => {
                            return {
                                link: link.href,
                                text: link.innerHTML
                            };
                        })
                    };
                
                else
                    return {link: item.querySelector(this.selectors.navLink).href, text: item.querySelector(this.selectors.navLink).innerHTML}
                
            }).filter(n=>n);
            newParent.innerHTML = NavMenu({data: menuItemsJson});
        }
    }

    buildTopicTabsAsScreens(): void {
        const tabsWidget = this.queryElm(this.selectors.topicsTabs) as HTMLElement;
        const tabsHeadings = this.queryElm(this.selectors.tabHeading, true, tabsWidget) as NodeListOf<HTMLElement>;
        const tabsContent = this.queryElm(this.selectors.tabContent, true, tabsWidget) as NodeListOf<HTMLElement>;
        
        if(!tabsHeadings.length || !tabsContent.length) return;

        const tabsAnchors =  [...(tabsHeadings as any)]
        .map((title, index) => [title, tabsContent[index]])
        .map(([title, content]) => {
            const screen = new SliderScreen(title.innerHTML, () => `<div class="p-3">${content.innerHTML}</div>`);
            this.slider.registerScreen(screen);
            const anchor = `
            <li class="side-menu__nav-menu__list-item side-menu__nav-menu__list-item--root">
                <a class="side-menu__nav-menu__link" ${
                    Object.entries(screen.getAnchorAttributes())
                    .reduce((prev, [key, val]) => `${prev} ${key}="${val}"`, '')
                }>  
                    ${title.innerHTML} 
                    <i class="icon-arrow-right" aria-hidden="true"></i>
                </a>
            </li>
            `;
            return anchor;
        });
        const rootScreen = new SliderScreen('Topics', () => `<div class="screen__topics p-3">${tabsAnchors.reduce((prev, current) => prev+current, '')}</div>`);
        rootScreen.id = 'topicsNav';
        this.slider.registerScreen(rootScreen);
    }

}

